function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { SEARCH_RESULT_CLEAR, SEARCH_RESULT_SAVE_PROFILE, SEARCH_RESULT_SCHOOL_START, SEARCH_RESULT_SCHOOL_UPDATE, SEARCH_RESULT_SET_EXPANDED_SCHOOL, SEARCH_RESULT_SET_PARAMETERS, SEARCH_RESULT_START, SEARCH_RESULT_UPDATE, SEARCH_SET_META, SEARCH_SET_SHOULD_VALIDATE_ELIGIBILITY, SEARCH_SET_TAB, SEARCH_NEXT_PAGE, SEARCH_SET_PAGE_LOADING } from "../actions/search";
function getInitialTab() {
  if (window && window.location && window.location.hash && window.location.hash.length > 0) {
    var locationHash = window.location.hash.substr(1);
    if (locationHash === 'programs' || locationHash === 'schools') {
      return locationHash;
    }
  }
  if (typeof window.location.pathname === 'string' && window.location.pathname.startsWith('/schools')) {
    return 'schools';
  }
  return 'programs';
}
var defaultState = {
  currentPage: 1,
  expandedSchool: null,
  hasStarted: false,
  isLoading: false,
  isPageLoading: false,
  meta: {},
  profiles: {},
  schoolResults: {},
  searchParameters: null,
  searchResults: null,
  shouldValidateEligibility: false,
  tab: getInitialTab()
};
var calculatePage = function calculatePage(state, pageNumber) {
  return Math.min(state.meta && state.meta.totalPages || 1, pageNumber);
};
var searchReducer = function searchReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (!action) return state;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case SEARCH_RESULT_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        hasStarted: true,
        searchResults: null,
        isLoading: true,
        expandedSchool: null,
        schoolResults: {}
      });
    case SEARCH_SET_PAGE_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isPageLoading: action.value
      });
    case SEARCH_RESULT_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchResults: action.append ? [].concat(_toConsumableArray(state.searchResults), _toConsumableArray(action.value)) : action.value,
        isLoading: false,
        expandedSchool: null,
        schoolResults: {}
      });
    case SEARCH_RESULT_SCHOOL_START:
      return _objectSpread(_objectSpread({}, state), {}, {
        schoolResults: _objectSpread(_objectSpread({}, state.schoolResults), {}, _defineProperty({}, action.programId, {
          isLoading: true,
          searchResults: null
        }))
      });
    case SEARCH_RESULT_SCHOOL_UPDATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        schoolResults: _objectSpread(_objectSpread({}, state.schoolResults), {}, _defineProperty({}, action.programId, {
          isLoading: false,
          searchResults: action.value
        }))
      });
    case SEARCH_RESULT_SET_EXPANDED_SCHOOL:
      return _objectSpread(_objectSpread({}, state), {}, {
        expandedSchool: action.value
      });
    case SEARCH_RESULT_SAVE_PROFILE:
      return _objectSpread(_objectSpread({}, state), {}, {
        profiles: _objectSpread(_objectSpread({}, state.profiles), {}, _defineProperty({}, action.value.student_id, action.value))
      });
    case SEARCH_RESULT_CLEAR:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchResults: null,
        hasStarted: false
      });
    case SEARCH_RESULT_SET_PARAMETERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        searchParameters: action.value,
        currentPage: 1
      });
    case SEARCH_SET_TAB:
      return _objectSpread(_objectSpread({}, state), {}, {
        tab: action.value
      });
    case SEARCH_SET_META:
      return _objectSpread(_objectSpread({}, state), {}, {
        meta: action.value
      });
    case SEARCH_NEXT_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: calculatePage(state, state.currentPage + 1)
      });
    case SEARCH_SET_SHOULD_VALIDATE_ELIGIBILITY:
      return _objectSpread(_objectSpread({}, state), {}, {
        shouldValidateEligibility: action.value
      });
  }
  return state;
};
export default searchReducer;